import { GET_SKILLS, GET_SKILLS_SUCCESS, GET_SKILLS_ERROR } from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  skills: [],
}

const SkillsList = (state = initialState, action) => {
  switch (action.type) {
    case GET_SKILLS:
      state = {
        ...state,
        loading: true,
      }
      break
    case GET_SKILLS_SUCCESS:
      state = {
        ...state,
        skills: action.payload.skills,
        loading: false,
        done: true,
      }
      break
    case GET_SKILLS_ERROR:
      state = { ...state, error: action.payload, loading: false, done: true }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default SkillsList
